import { Link } from 'react-router-dom';
import styled, { css } from 'styled-components';

import { Box } from '@sternum/styled-system';
import { DataGrid } from '@sternum/ui';
import { Colors } from '@sternum/web/components/theme/constants';
import { ct } from '@sternum/web/utils/theme';

export const DataGridHead = styled(DataGrid.Head)`
  border-radius: 0;
  background: ${ct({ Dark: Colors.GreyDarkest, Light: Colors.Lightest })};
  z-index: 100;
  border-bottom: 1px solid ${ct({ Dark: Colors.Lighter, Light: Colors.Lighter })};
`;

export const HeaderCellSkeleton = styled(Box)`
  width: 64px;
  height: 8px;
  border-radius: 4px;
  background-color: ${ct({ Dark: Colors.Grey, Light: Colors.Grey })};
`;

export const BodyCellSkeleton = styled.div`
  margin: auto 0;
  width: 90%;
  height: 8px;
  border-radius: 4px;
  background-color: ${ct({ Dark: Colors.GreyLightest, Light: Colors.GreyLightest })};
`;

export const DataGridRowStyled = styled(DataGrid.Row)`
  align-items: center;
  border: solid ${ct({ Dark: Colors.Lighter, Light: Colors.Lighter })};
  border-width: 1px 0 0 0;

  &&:hover {
    background: ${ct({ Dark: Colors.Lighter, Light: Colors.Lighter })};
  }

  &&:nth-child(even) ${BodyCellSkeleton} {
    width: 65%;
  }
`;

export const StyledCell = styled(DataGrid.Cell)<{ $isSeverityCell?: boolean; $shouldApplyFlexEnd: boolean }>`
  align-items: center;
  color: ${ct({ Dark: Colors.DarkerMiddle, Light: Colors.DarkerMiddle })};
  text-align: right;
  height: 40px;
  display: flex;
  ${({ $isSeverityCell }) => ($isSeverityCell ? 'padding: 0;' : 'padding: 12px 16px;')}
  ${({ $shouldApplyFlexEnd }) => $shouldApplyFlexEnd && `justify-content: flex-end;`}
`;

export const StyledCellLink = styled(Link)`
  text-decoration: none;
  color: inherit;

  &:hover {
    text-decoration: underline;
  }
`;

export const StyledHeaderCell = styled(Box)<{ $shouldApplyFlexEnd?: boolean }>`
  & div {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    ${({ $shouldApplyFlexEnd }) =>
      $shouldApplyFlexEnd &&
      css`
        display: flex;
        justify-content: flex-end;
      `}
  }

  & div:first-child {
    width: 100%;
    font-size: 10px;
  }
`;

export const StyledHeaderText = styled(Box)`
  letter-spacing: 0.48px;
`;

export const StyledEmptyState = styled.div`
  display: flex;
  font-weight: 600;
  font-size: 20px;
  color: ${ct({ Dark: Colors.White, Light: Colors.GreyDarker })};
`;
